import * as setting from './setting.js';

export default {
    setting,
};

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

// Global Access
if (window.EQLAPP) {

    // Admin
    window.EQLAPP.SETTING = window.EQLAPP.SETTING || {};
    Object.entries(setting).forEach(([key, value]) => {
        window.EQLAPP.SETTING[key] = value;
    });

}